module.exports = __webpack_public_path__ + "img/selected7-min.e77e7c62.png";